@use '../../utils.scss';
@use '../../base-variables.scss';

.Checkbox {
	width: 16px;
	height: 16px;
	min-width: 16px;
    min-height: 16px;
	border: 1px solid utils.color('standby-blue-gray');
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 3px;
	cursor: pointer;
	&.Active {
		background-color: utils.color('nebula');
		border-color: utils.color('nebula');
	}
}
.ChkbxLabel {
	margin-left: 8px;
}
.Disabled {
	opacity: 0.6;
	cursor: auto;
}